import { MoreHoriz } from '@mui/icons-material';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useTheme,
} from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import {
  BOTTOM_NAV_ITEMS,
  MORE_KEY,
  MORE_LABEL,
  getActiveNavItem,
} from '../../constants/navigation';

/**
 * 모바일 하단탭: 홈 / 포트폴리오 / 계좌 / 공모주 / 더보기.
 * - 하단탭에 없는 페이지(거래내역, 배당, AI 분석, 시뮬레이션, 전략투자, 설정)는 "더보기" 가 선택 표시된다.
 * - 목록에 없는 경로(예: /stocks/:code)는 아무 탭도 선택하지 않는다.
 * - "더보기" 는 모바일 드로어(MobileNavigation)를 연다. Layout 이 onMoreClick 으로 연결한다.
 */
const MobileBottomNavigation = ({ onMoreClick }) => {
  const location = useLocation();
  const theme = useTheme();

  const activeItem = getActiveNavItem(location.pathname);
  let currentValue = false;
  if (activeItem) {
    currentValue = activeItem.bottomTab ? activeItem.key : MORE_KEY;
  }

  const handleChange = (event, newValue) => {
    // 일반 탭은 <a href> 링크가 이동을 처리한다. "더보기" 만 드로어를 연다.
    if (newValue === MORE_KEY && onMoreClick) {
      onMoreClick();
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderTop: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[8],
      }}
      elevation={8}
    >
      <BottomNavigation
        component="nav"
        aria-label="하단 메뉴"
        value={currentValue}
        onChange={handleChange}
        showLabels
        sx={{
          height: { xs: 56, sm: 60 },
          pt: '2px',
          pb: '2px',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            pt: '2px',
            pb: '2px',
            px: 0.5,
            minHeight: 'auto',
            '&.Mui-selected': {
              color: theme.palette.primary.main,
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: { xs: '0.65rem', sm: '0.7rem' },
            fontWeight: 500,
            lineHeight: 1.2,
            mt: '1px',
            whiteSpace: 'nowrap',
            '&.Mui-selected': {
              fontSize: { xs: '0.7rem', sm: '0.75rem' },
              fontWeight: 600,
            },
          },
        }}
      >
        {BOTTOM_NAV_ITEMS.map((item) => (
          <BottomNavigationAction
            key={item.key}
            value={item.key}
            component={RouterLink}
            to={item.path}
            label={item.shortLabel}
            icon={<item.Icon />}
            aria-current={currentValue === item.key ? 'page' : undefined}
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: '1.2rem',
              },
            }}
          />
        ))}
        <BottomNavigationAction
          value={MORE_KEY}
          label={MORE_LABEL}
          icon={<MoreHoriz />}
          aria-haspopup="dialog"
          aria-current={currentValue === MORE_KEY ? 'true' : undefined}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: '1.2rem',
            },
          }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNavigation;
